import { commonClasses } from "components-redesign/styles";
import { makeStyles } from "components/mui-core";

const useCommonStyle = makeStyles()(commonClasses as any);

function FormFieldError({ id, text }) {
  const { classes: commonStyles } = useCommonStyle();

  return (
    <div
      className={commonStyles.errorText}
      style={{ marginLeft: 0 }}
      id={id + "-error"}>
      {text}
    </div>
  );
}

export default FormFieldError;
